import { Tabs } from 'antd'
import React from 'react'
import { t } from 'i18next'
import EventsTab from './EventsTab'
import FeedbackForm from './FeedbackForm'
import LogsPanel from './LogsPanel'
import SMSPanel from '../SMSPanel/SMSPanel'
import AdminSlotForm from './AdminSlotForm'

export default function AdminSlotCardTabs ({ form, slot, setSlot, loading, setLoading, setIsDirty }) {
  return (
    <>
      { slot &&
        <Tabs style={{ marginBottom: '1em' }}
          defaultActiveKey='form'
          items={[
            {
              label: t('Admin.AdminSlotPage.tab.form'),
              key: 'form',
              children: <AdminSlotForm form={form} slot={slot} setSlot={setSlot} setLoading={setLoading} loading={loading} />
            },
            {
              label: t('Admin.AdminSlotPage.tab.log'),
              key: 'log',
              children: <LogsPanel slot={slot} />
            },
            {
              label: t('Admin.AdminSlotPage.tab.sms'),
              key: 'sms',
              children: <SMSPanel owner={slot} ownerType="slots" setLoading={setLoading} />
            },
            {
              label: t('Admin.AdminSlotPage.tab.events'),
              key: 'events',
              children: <EventsTab slot={slot} setLoading={setLoading} />
            },
            {
              label: t('Admin.AdminSlotPage.tab.feedback'),
              key: 'feedback',
              children: <FeedbackForm slot={slot} setLoading={setLoading} setSlot={setSlot} setIsDirty={setIsDirty} />
            }
          ]}
        />
      }
    </>
  )
}
